import React, { useState } from 'react';
import './GameLobby.css';

function GameLobby({ onCreateGame, onJoinGame, onPlayAI, onPlayGuest, onLearn, error }) {
  const [playerName, setPlayerName] = useState('');
  const [roomName, setRoomName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateRoomName = (name) => {
    // Must be 4-8 uppercase letters
    return /^[A-Z]{4,8}$/.test(name);
  };

  const handlePlayAI = async () => {
    // Only need player name for AI games
    if (!playerName.trim()) {
      alert('Please enter your name');
      return;
    }
    
    setIsLoading(true);
    // Generate a unique room code for AI game
    const aiRoomCode = 'AI' + Math.random().toString(36).substring(2, 8).toUpperCase();
    const success = await onPlayAI(aiRoomCode, playerName);
    setIsLoading(false);
    
    if (!success) {
      // Error will be shown via error prop
    }
  };

  const handlePlayGuest = () => {
    // Guest mode: No name required, instant play
    onPlayGuest();
  };

  const handleNewGame = async () => {
    // Validate name
    if (!playerName.trim()) {
      alert('Please enter your name');
      return;
    }
    
    // Validate room name
    if (!roomName.trim()) {
      alert('Please enter a room name');
      return;
    }
    
    const upperRoomName = roomName.toUpperCase();
    if (!validateRoomName(upperRoomName)) {
      alert('Room name must be 4-8 letters (A-Z only)');
      return;
    }
    
    setIsLoading(true);
    const success = await onCreateGame(upperRoomName, playerName);
    setIsLoading(false);
    
    if (!success) {
      // Error will be shown via error prop
    }
  };

  const handleJoinGame = async () => {
    // Validate name
    if (!playerName.trim()) {
      alert('Please enter your name');
      return;
    }
    
    // Validate room name
    if (!roomName.trim()) {
      alert('Please enter a room name');
      return;
    }
    
    const upperRoomName = roomName.toUpperCase();
    if (!validateRoomName(upperRoomName)) {
      alert('Room name must be 4-8 letters (A-Z only)');
      return;
    }
    
    setIsLoading(true);
    const success = await onJoinGame(upperRoomName, playerName);
    setIsLoading(false);
    
    if (!success) {
      // Error will be shown via error prop
    }
  };

  return (
    <div className="lobby-container">
      <div className="lobby-card">
        <h1>🎴 Casino Card Game</h1>
        
        <div className="learn-link-section">
          <button onClick={onLearn} className="learn-link-btn">
            📖 How to Play
          </button>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <div className="input-section">
          <label>Your Name:</label>
          <input
            type="text"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="Enter your name"
            maxLength={20}
            disabled={isLoading}
          />
        </div>

        <div className="input-section">
          <label>Room Name:</label>
          <input
            type="text"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value.toUpperCase())}
            placeholder="4-8 letters"
            maxLength={8}
            disabled={isLoading}
          />
          <p className="helper-text">For multiplayer games (optional for AI)</p>
        </div>

        <div className="button-section">
          <button 
            className="new-game-button"
            onClick={handleNewGame}
            disabled={!playerName.trim() || !roomName.trim() || isLoading}
          >
            {isLoading ? 'Creating...' : 'New Game'}
          </button>
          
          <button 
            className="join-game-button"
            onClick={handleJoinGame}
            disabled={!playerName.trim() || !roomName.trim() || isLoading}
          >
            {isLoading ? 'Joining...' : 'Join Game'}
          </button>
        </div>

        <div className="divider">OR</div>

        <div className="button-section">
          <button 
            className="ai-game-button"
            onClick={handlePlayAI}
            disabled={!playerName.trim() || isLoading}
          >
            {isLoading ? 'Starting...' : 'Play vs AI'}
          </button>
        </div>

        <div className="divider">OR</div>

        <div className="button-section">
          <button 
            className="guest-play-button"
            onClick={handlePlayGuest}
            disabled={isLoading}
          >
            ⚡ Play Now (Guest Mode)
          </button>
          <p className="helper-text">Instant play vs AI - no login required</p>
        </div>
      </div>
    </div>
  );
}

export default GameLobby;
